import { type Effect, createStore, sample } from 'effector';
import { isEqual } from 'lodash';

export default function createFxPendingsStore<T, U, V>(fx: Effect<T, U, V>) {
    const $pendings = createStore<T[]>([]);
    sample({
        source: $pendings,
        clock: fx,
        fn: (pendings, newArgs) => [...pendings, newArgs],
        target: $pendings,
    });
    sample({
        source: $pendings,
        clock: fx.finally,
        fn: (pendings, newArgs) => pendings.filter((p) => !isEqual(p, newArgs.params)),
        target: $pendings,
    });
    return $pendings;
}
